import { render, staticRenderFns } from "./CosmoClawInput.vue?vue&type=template&id=30db08cc&scoped=true"
import script from "./CosmoClawInput.vue?vue&type=script&lang=js"
export * from "./CosmoClawInput.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawInput.vue?vue&type=style&index=0&id=30db08cc&prod&lang=scss&scoped=true"
import style1 from "./CosmoClawInput.vue?vue&type=style&index=1&id=30db08cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db08cc",
  null
  
)

export default component.exports